<script>
    import { createEventDispatcher } from "svelte";
    import tagService from "./service.js";
    import { notificate } from "../../services/notification.js";
    import { flatten422Errors, search } from "../../services/api.svelte.js";
    import { translateErrorMessages } from "../../services/api.svelte.js";
    import { form as svForm, field } from "svelte-forms";
    import { required } from "svelte-forms/validators";
    import workspaceService from "../../services/workspace.js";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    export let tag;

    let formData = {};
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    let tagRegexError = null;
    // API 422 errors
    let formApiErrors = {};
    let assets = [];
    let assets_are_loading = false;
    let search_results;
    let search_result = "";
    let showDropdown = false;
    let has_searched_once = false;
    let assetsToAssociate = [];
    let assetsToRemove = [];
    let assetsAssociated = [];
    let assetKind;
    let is_edit;

    // add form
    if (!tag) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: tag.name,
        };
        is_edit = true;
        assetsAssociated =
            tag.assets || tag.asset ? JSON.parse(tag.assets || tag.asset) : [];
    }

    //form fields
    const nameField = field("name", "", [required()]);

    const myForm = svForm(nameField);

    function containsUppercase(str) {
        return /[A-Z]/.test(str);
    }

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        if (!$myForm.valid) {
            notificate("422");
            return false;
        }
        if (containsUppercase(formData.name))
            return (tagRegexError = $format("page.tag.invalid_characters"));
        formData.name = $nameField.value;

        tagService
            .save(formData, [])
            .then((savedTag) => {
                dispatch("save", { savedTag });
                //clear formData and form status and errors
                // when modal is closed after sending add request
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                return true;
            })
            .catch((errors) => {
                if (typeof errors.detail == "string") {
                    APIerror = translateErrorMessages(
                        errors.detail,
                        "Etiquetas",
                    );
                } else {
                    // parse API errors
                    formApiErrors = flatten422Errors(errors);
                }

                return false;
            });
    }

    function handleCloseModal() {
        formData = {};
        formApiErrors = {};
        formIsSubmitted = false;
        showDropdown = true;
        APIerror = null;
        assetKind = null;
        assets = [];
        search_results = [];
        assetsToAssociate = [];
        dispatch("closeModal");
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") {
            handleCloseModal();
        } else {
            return;
        }
    };
</script>

<svelte:window on:keydown={handleKeydown} />

<form role="form" novalidate on:submit|preventDefault={handleSubmit}>
    <div class="card">
        <div class="card-body">
            <div class="mb-3">
                <label for="name"
                    >{$format("form.fields.name")}<span class="text-danger"
                        >*</span
                    ></label
                >
                <input
                    type="text"
                    class="form-control t-input-tag-name"
                    id="name"
                    name="name"
                    placeholder={$format("form.fields.name")}
                    bind:value={$nameField.value}
                />
                <small>{$format("page.tag.warning")}</small>
                {#if tagRegexError}<div class="mt-3 text-danger">
                        {tagRegexError || ""}
                    </div>{/if}
                {#if APIerror}<div class="mt-3 text-danger">
                        {APIerror || ""}
                    </div>{/if}
            </div>

            <div class="card-footer">
                <button type="submit" class="btn btn-primary t-submit-tag-btn"
                    >{$format("buttons.save")}</button
                >
                <button
                    type="button"
                    class="btn btn-default"
                    data-bs-dismiss="modal"
                >
                    {$format("buttons.cancel")}
                </button>
            </div>
        </div>
    </div>
</form>

<style>
    .btnDeleteAsset {
        cursor: pointer;
    }
</style>
